<template>
  <div id="Waves">
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">Sign in to start your session.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <!--      <div class="separator separator-bottom separator-skew zindex-100">-->
      <!--        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">-->
      <!--          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>-->
      <!--        </svg>-->
      <!--      </div>-->

    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">

      <b-row  v-if="!loginValue" class="justify-content-center">

        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-header class="bg-transparent pb-5 justify-content-center"><h4>Authenticating</h4></b-card-header>
            <b-card-body class="px-lg-5 py-lg-5 justify-content-center">
              <div class="text-center w-100 mb-4">
                <b-icon icon="three-dots"
                        class="text-center " animation="cylon"
                        font-scale="4"></b-icon>
              </div>
              <p class="justify-content-center">
                Please wait while we validate your credentials.
              </p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="justify-content-center" v-if="loginValue">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-header class="bg-transparent pb-5" style="display:none;">
              <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </b-card-header>

            <b-card-body class="px-lg-5 py-lg-5">
             
              <div class="text-center text-muted mb-4">
                <small>If your account was found, an e-mail has been sent to the associated e-mail address. Enter the code and your new password.</small>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-button :variant="validationCode?'outline-success': 'outline-danger'">
                        <i class="fa fa-check"></i>
                      </b-button>
                    </b-input-group-prepend>
                    <b-form-input
                        id="confirmCode"
                        v-model="loginForm.confirmCode"
                        :state="validationCode"
                        placeholder="Confirm Code"
                        aria-describedby="code-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="code-feedback" :state="validationCode">
                      Input confirm code
                    </b-form-invalid-feedback>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-button :variant="validationUsername?'outline-success': 'outline-danger'">
                        <i class="fa fa-user"></i>
                      </b-button>
                    </b-input-group-prepend>
                    <b-form-input
                        id="username"
                        v-model="loginForm.userName"
                        :state="validationUsername"
                        placeholder="Input Username"
                        aria-describedby="username-feedback"
                        disabled
                    ></b-form-input>
                    <b-form-invalid-feedback id="username-feedback" :state="validationUsername">
                      Input valid username
                    </b-form-invalid-feedback>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-button :variant="validationPassword?'outline-success': 'outline-danger'">
                        <i class="fas fa-key"></i>
                      </b-button>
                    </b-input-group-prepend>
                    <b-form-input
                        id="input-valid"
                        type="password"
                        v-model="loginForm.password"
                        :state="validationPassword"
                        placeholder="Input Password"
                        aria-describedby="password-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="!passwordLength">
                      Your password must have at least 8 chars.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!passwordUppercase">
                      Your password must have at least 1 upper case letter.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!passwordNumber">
                      Your password must have at least 1 number.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!passwordCharacter">
                      Your password must have at least 1 special char.
                    </b-form-invalid-feedback>
                  </b-input-group>

                  <div class="text-center w-100">
                    <base-button type="primary" native-type="submit" class="my-4 w-100" :loading="submitLoading" :disabled="buttonStatus()">Reset Password</base-button>
                  </div>
                  <router-link to="/forgot" class="text-light" custom v-slot="{navigate}">
                    <a @keypress.enter="navigate" @click="navigate" role="link">
                      <div class="text-center w-100">
                        <p class="text-primary text-center cursor-pointer "><u>Resend Code  </u></p>
                      </div>
                    </a>
                  </router-link>
                  
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
    import AuthService from "@/common/api-services/auth-service";

    export default {
        name: "Reset-Password",
      data() {
        return {
          loginForm: {
            confirmCode: '',
            userName: '',
            password: '',
          },
          errorMessage: '',
          loginValue: true,
          submitLoading: false,
        };
      },
      computed: {
        validationCode() {
          return (this.loginForm.confirmCode.length > 0 && !this.loginForm.confirmCode.includes(' '))
        },
        validationUsername() {
          return (this.loginForm.userName.length > 0 && !this.loginForm.userName.includes(' '));
        },
        validationPassword() {
          return !!(this.loginForm && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
        },
        passwordLength() {
          return this.loginForm.password.length > 7
        },
        passwordUppercase() {
          let pass = this.loginForm.password;
          for (let i = 0; i < pass.length; i++) {
            if ('A' <= pass[i] && pass[i] <= 'Z') {
              return true;
            }
          }
        },
        passwordNumber() {
          let pass = this.loginForm.password;
          for (let i = 0; i < pass.length; i++) {
            if ('0' <= pass[i] && pass[i] <= '9') {
              return true;
            }
          }
        },
        passwordCharacter() {
          let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
          if (format.test(this.loginForm.password)) {
            return true
          }
        },
      },
      mounted() {
        this.$root.$emit('renderBackground', true);
      },
      methods: {
        buttonStatus() {
          if (!this.validationCode || !this.validationUsername || !this.validationPassword) {
            return true;
          } else {
            return false
          }
        },
        onSubmit() {
          this.submitLoading = true;
          let credentials = btoa(this.loginForm.userName + '|' + this.loginForm.password);
          AuthService.resetPassword(credentials, this.loginForm.confirmCode).then(res => {
            this.submitLoading = false;
            if (res && !res.data.message.includes('FAIL')) {
              this.$toast.success('Successfully changed')
              setTimeout(() => {
                this.$router.push({name: 'login'})
              }, 1000)
            } else {
              this.$toast.error('Code is not valid. Please recheck')
            }
          })
        }
      }, 
      created() {
        console.log(this.$route.params.username)
        if (this.$route.params.username) {
          this.loginForm.userName = this.$route.params.username
        } else {
          this.$router.push({'name': 'Forgot'})
        }
      }
    }
</script>
